<template>
  <div style="width: 100%">
    <vxe-toolbar size="mini" v-if="!isHiddenTopBtn">
      <template v-slot:buttons>
        <template>
          <el-button type="primary" size="small" class="vxe-btn-primary" @click="addNewRowHandler"
            >新增</el-button
          >
          <el-button
            size="small"
            type="danger"
            class="vxe-btn-delete"
            @click="deleteBtnClickHandler()"
            >删除</el-button
          >
        </template>
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-grid
      border
      auto-resize
      resizable
      show-overflow
      keep-source
      ref="xTableRef"
      class="vxe-table-element"
      size="mini"
      align="left"
      :data="tableData"
      :columns="tableColumnsList"
      :edit-rules="tableRules"
      :edit-config="editConfig"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :show-footer="true"
      :footer-method="footerMethod"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
      @edit-closed="closeEditTableHandler"
    >
    </vxe-grid>
  </div>
</template>

<script>
  import API from '@/api/dataBase.js';

  export default {
    name: 'AgreementTable',
    props: {
      companyCode: {
        type: String,
        default: '',
      },
      orderDetailList: {
        type: Array,
        default: () => [],
      },
      detailPageData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        tableData: [],
        tableRules: {},
        editConfig: { trigger: 'click', mode: 'row' },
        selectionList: [],
        isHiddenTopBtn: false,
        ids: [],
        companyList: [],
      };
    },
    computed: {
      tableColumnsList() {
        return [
          { type: 'checkbox', width: 50 },
          { type: 'seq', title: '序号', width: 50 },
          { type: 'seq', title: '行项目号', width: 100 },
          {
            field: 'productDesc',
            title: '商品描述',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['productDesc']}</span>];
              },

              edit: ({ row }) => {
                return [
                  <SearchTable
                    searchType="usableProduct"
                    isMultiple={true}
                    extraData={{
                      detailProductStatus: 'ZT03',
                      contractCategory: 'purchase',
                      adminFlag: 2,
                      selectCompanyCode: this.companyCode || this.userInfo.companyCode,
                      businessCompanyCodeList: this.companyList,
                    }}
                    currentValue={row['productDesc']}
                    checkRowKeys={[row['productNo']]}
                    onInput={(val) => this.chooseTable(val, row, 'productDesc')}
                  ></SearchTable>,
                ];
              },
            },
          },
          {
            field: 'productQuantity',
            title: '采购数量',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['productQuantity']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['productQuantity']}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => (row['productQuantity'] = val)}
                  ></InputNumberAd>,
                ];
              },
            },
          },
          {
            field: 'unitName',
            title: '单位',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                placeholder: '请输入单位',
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['unitName']}</span>];
              },
              edit: ({ row }) => {
                return [<span>{row['unitName']}</span>];
              },
            },
          },
          {
            field: 'isFixedPrice',
            title: '是否定价',
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
              },
              options: [
                {
                  label: '是',
                  value: '1',
                },
                {
                  label: '否',
                  value: '0',
                },
              ],
              events: {
                input: (obj) => this.updateCol(obj.row['isFixedPrice'], obj.row, 'isFixedPrice'),
              },
            },
          },
        ];
      },
    },
    methods: {
      // 获取当前登陆人下面的所有公司数据
      async getCompany() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        this.$axios.post(API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            // 获取公司下拉
            let companyList = res.data.data.personCompanyInfo || [];
            this.companyList = companyList.map((item) => {
              return item?.personCompanyCode;
            });
          }
        });
      },
      updateCol(val, row, field) {
        console.log(field, '当前字段', val);
        if (field == 'isFixedPrice') {
          row['isFixedPrice'] = val;
          row['priceIdentity'] = val;
        }
      },
      // 表格底部
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['productQuantity'].includes(column.property)) {
              return (+data.reduce((cur, next) => cur + +next.productQuantity, 0)).toFixed(8);
            }
            return '-';
          }),
        ];
      },
      handleSelectionChange(row) {
        this.selectionList = row.selection;
      },
      // 选择商品的时候
      chooseTable(val, row, filed) {
        console.log(val, row, filed, '===');
        const product = val[0];
        if (product) {
          // row.productNo = product.parentProductNo;
          if (product?.productDetailCode && product?.productDetailCode.length != 0) {
            row['productNo'] = product?.productDetailCode;
          } else {
            row['productNo'] = product?.parentProductNo;
          }
          row.productDesc = product.productChName;
          row.unit = product.basicUnit || null;
          row.unitName = product.basicUnitName || null;
          row.customsId = product.customsId || null;
          row.taxRate = product.valueAddedTaxRate || 0;
          row.taxCode =
            this.$route.query.contractCategory == 'sales'
              ? product.salesTaxCode
              : product.valueAddedTaxCode;
          row.taxName = row.taxCode
            ? this.addedTaxRateOptions.find((options) => {
                return row.taxCode == options.taxCode;
              }).taxName
            : '';
          row.valueAddedTaxRate = product.salesTaxRate || null;
          // 进口普通关税率
          row.importNormalTariffRate = product.importNormalTariffRate || null;
          // 单独处理生成销售合同时候的合同标
          if (product?.productDetailCode && product?.productDetailCode.length != 0) {
            row['contractMatter'] = product?.productDetailCode;
          } else {
            row['contractMatter'] = product?.parentProductNo;
          }
          row.contractMatterName = product?.productChName;
          //出口 转口 税率取出口退税率   其他是消费税率
          if (this.tradeType != '') {
            if (this.$route.query.contractCategory == 'sales') {
              row.consumptionTaxRate = product.salesTaxRate;
              row.taxRefundRate = product.taxRefundRate;
              row.taxRate = product.salesTaxRate;
              //销售-- 销项税码
              if (this.tradeType == 'MY04' || this.tradeType == 'MY03') {
                row.consumptionTaxRate = 0;
                //销售 -出口  04 转口 03 // 采购 -进口02
              }
            } else {
              row.valueAddedTaxRate = product.valueAddedTaxRate;
              row.taxRate = product.valueAddedTaxRate;
              //采购 --进项税码
              if (this.tradeType == 'MY03' || this.tradeType == 'MY02') {
                row.valueAddedTaxRate = 0;
                //采购 -转口 -进口02
                row.importNormalTariffRate = product.importNormalTariffRate; //importNormalTariffRate
              }
            }
          }
        }
      },
      // 新增一行
      async addNewRowHandler() {
        const $table = this.$refs.xTableRef;
        const { row } = await $table.insertAt({}, 0);
        await $table.setActiveRow(row);
      },
      // 删除行
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行再删除');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
      },
      // 获取表格数据
      getValidateTableData() {
        return new Promise((resolve) => {
          const $table = this.$refs.xTableRef;
          const tableData = $table.getTableData().fullData;
          $table.validate((valid) => {
            console.log(valid);
            const currentStatus = this.$route.query.status;
            const formTableData = tableData.map((item, index) => {
              return {
                ...item,
                isFixedPrice: item.isFixedPrice + '',
                departmentCode: this.userInfo.departmentCode,
                departmentName: this.userInfo.departmentName,
                companyCode: this.userInfo.companyCode,
                companyName: this.userInfo.companyName,
                contractDetailNo: index + 1, // 行项目号
                taxRate: item.taxRate ? item.taxRate : 0,
                // 特殊处理id
                id:
                  ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01'
                    ? ''
                    : item?.id,
              };
            });
            resolve({ orderDetailList: formTableData, orderDetailDelIds: this.ids });
          });
        });
      },
      // 关闭的时候数据校验
      closeEditTableHandler() {
        this.$emit('closeTableHandler', this.getTableData());
      },
      getTableData() {
        const $table = this.$refs.xTableRef;
        return $table.getTableData().fullData;
      },
      fullTableData(tableData) {
        this.tableData = tableData.map((item) => {
          return {
            ...item,
            isFixedPrice: item.isFixedPrice + '',
          };
        });
      },
    },
    watch: {
      detailPageData: {
        handler(val) {
          if (val?.contractStatus) {
            console.log(val?.contractStatus, '监听当前状态');
            // TODO 这块需求未全面确定，先一个状态一个状态判断
            const currentContractStatus = val?.contractStatus; // 'ZT021';
            if (currentContractStatus == 'ZT02') {
              // 审批中
              this.editConfig = {};
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT03') {
              // 已生效
              this.editConfig = {};
              this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT07') {
              // 已关闭状态表格不能编辑按钮没有
              this.editConfig = {};
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT021') {
              // 修订审批中
              this.editConfig = {};
              this.isShowVariablePriceIcon = true;
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT021') {
              // 审批修订中
              this.editConfig = {};
              this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT025') {
              // 删除审批中
              this.editConfig = {};
              this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT024') {
              // 生效审批中
              this.editConfig = {};
              this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT022') {
              // 撤回审批中
              this.editConfig = {};
              this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT023') {
              // 关闭审批中
              // 撤回审批中
              this.editConfig = {};
              this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT061') {
              // 修订中,部分控件要禁止
              this.currentDisabledFiledList = [
                'materialType',
                'productQuantity2',
                'isFixedPrice',
                'priceConfirmDate',
                'priceIdentity',
                'variablePrice',
                'businessChangeUnitPrice',
                'shipmentPlace',
                'destination',
              ];
            } else if (currentContractStatus == 'ZT051') {
              // 修改已驳回,部分控件要禁止
              this.currentDisabledFiledList = [
                'materialType',
                'productQuantity2',
                'isFixedPrice',
                'priceConfirmDate',
                'priceIdentity',
                'variablePrice',
                'businessChangeUnitPrice',
                'shipmentPlace',
                'destination',
              ];
            } else {
              console.log('等待处理');
            }

            if (this.$route.query.isCopy) {
              this.editConfig = { trigger: 'click', mode: 'row' };
              this.isHiddenTopBtn = false;
            }
          }
        },
      },
      orderDetailList: {
        handler(val) {
          if (val && Array.isArray(val)) {
            this.fullTableData(val);
          }
        },
        immediate: true,
      },
    },
    mounted() {
      this.getCompany();
    },
  };
</script>

<style lang="scss" scoped></style>
